import { useAuthContext } from './agencyAuthHook'
import { getAllInstructions } from '../redux/reducers/instructionsSlice'
import { useDispatch } from 'react-redux';

export default function InstructionsHook() {
    const dispatch = useDispatch()
    const apiUrl = process.env.REACT_APP_API_URL;
    const { agency } = useAuthContext()
    const getInstructions=async()=>{
       try {
        const response=await fetch(`${apiUrl}/api/agencies/instructions/get`,{
          headers:{
            'Authorization': `Bearer ${agency.token}`
            
          }
        })
        
        const json=await response.json()
        if(response.ok){
          
          dispatch(getAllInstructions(json.data))
        }
        
       } catch (error) {
       console.log('error',error)
       }
    }
  return {getInstructions}
}
